import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const RULE_CATEGORIES_REQUEST = 'FETCH_RULE_CATEGORIES_REQUEST';
export const RULE_CATEGORIES_FAILURE = 'FETCH_RULE_CATEGORIES_FAILURE';
export const RULE_CATEGORIES_SUCCESS = 'FETCH_RULE_CATEGORIES_SUCCESS';

export const fetchRuleCategories = () => {
    return function(dispatch) {
        dispatch(fetchRuleCategoriesRequest());
        return axios(apiRequestOptions(apiPath.RULE_CATEGORIES.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchRuleCategoriesSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchRuleCategoriesFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRuleCategoriesRequest = () => {
    return {
        type: RULE_CATEGORIES_REQUEST,
    }
};

const fetchRuleCategoriesFailure = (error) => {
    return {
        type: RULE_CATEGORIES_FAILURE,
        error,
    }
};

const fetchRuleCategoriesSuccess = (data) => {
    return {
        type: RULE_CATEGORIES_SUCCESS,
        data,
    }
};